import React from 'react';
import { FaUserGraduate, FaUsers, FaMedal } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const UserCategories = () => {
  const { t } = useTranslation();

  const categories = [
    {
      icon: <FaUserGraduate />,
      title: t('userCategories.categories.0.title'),
      description: t('userCategories.categories.0.description')
    },
    {
      icon: <FaUsers />,
      title: t('userCategories.categories.1.title'),
      description: t('userCategories.categories.1.description')
    },
    {
      icon: <FaMedal />,
      title: t('userCategories.categories.2.title'),
      description: t('userCategories.categories.2.description')
    }
  ];

  return (
    <section className="user-categories" id="for-whom">
      <div className="container">
        <h2 className="section-title">{t('userCategories.title')}</h2>
        <p className="section-description">{t('userCategories.description')}</p>
        <div className="categories-container">
          {categories.map((category) => (
            <article key={category.title} className="category-card">
              <div className="category-icon" aria-hidden="true">
                {category.icon}
              </div>
              <h3 className="category-title">{category.title}</h3>
              <p className="category-description">{category.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UserCategories;
